import { useTranslation } from '../../common/i18n/useTranslation';
import { green, grey as greyColor, yellow } from '@mercedes-benz/mui5-theme/build/main/lib/Colors';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { WbGridCol, WbGridRow, WbIcon, WbTag, WbText } from '@workbench/react';
import MailToButton from '../MailToButton';
import { OPERATING_FLUID_MAIL_ADDRESS } from '../../utils/links';

const useStyles = makeStyles()((theme: Theme) => ({
    spacing: {
        marginBottom: theme.spacing(3),
    },
    typography: {
        color: greyColor[95],
    },
    typographyUnderline: {
        color: greyColor[95],
        textDecoration: 'underline',
    },
    flagIcon: {
        fill: greyColor[95],
    },
    chipGreen: { backgroundColor: green[60], color: greyColor[95] },
    chipYellow: { backgroundColor: yellow[65], color: greyColor[5] },
}));

function RegistrationRejected() {
    const translate = useTranslation();
    const { classes } = useStyles();

    return (
        <WbGridRow className={classes.spacing}>
            <WbGridCol mq1={5}>
                <WbText size="m">{translate('reg_rejected')}</WbText>
                <WbText size="m">
                    {translate('reg_rejected_questions')}
                    <MailToButton mailto={OPERATING_FLUID_MAIL_ADDRESS} label={OPERATING_FLUID_MAIL_ADDRESS} />
                </WbText>
            </WbGridCol>
            <WbGridCol mq1={3}>
                <WbTag variant="error">
                    <WbIcon name="bds/exclamation-mark-circle-outline/24" />
                    {translate('reg_rej')}
                </WbTag>
            </WbGridCol>
        </WbGridRow>
    );
}

export default RegistrationRejected;
